document.addEventListener('DOMContentLoaded', function () {
    const header = document.querySelector('header.header');
    const trading = document.querySelector('.trading');
    const userDropdown = header.querySelector('.user-dropdown');
    const userDropdownList = header.querySelector('.user-dropdown__list');
    const containersForGreeting = header.querySelectorAll('.js-get-greeting');

    // Add opacity for header on home page
    if (m.about.page.search('home-page') !== -1) {
        header.classList.add('header_opacity');

        document.addEventListener('scroll', () => {
            if (trading.getBoundingClientRect().top < 0 && header.matches('.header_opacity')) {
                header.classList.remove('header_opacity');
            } else if (trading.getBoundingClientRect().top > 0 && !header.matches('.header_opacity')) {
                header.classList.add('header_opacity');
            }
        });
    }

    // smartbanner behavior
    const smartbanner = document.querySelector('#smartbanner');

    if (m.about.device === 'mobile' && smartbanner) {
        ['DOMContentLoaded', 'scroll'].forEach(event => {
           document.addEventListener(event, () => {
               const main = document.querySelector('main');
               const header = document.querySelector('.header');

               (pageYOffset > main.offsetTop)
                   ? header.classList.add('header_fixed')
                   : header.classList.remove('header_fixed');
           }) ;
        });
    }

    // toggle user dropdown list
    userDropdown.addEventListener('click', e => {
        e.stopPropagation();
        userDropdownList.classList.toggle('user-dropdown__list_active');

        document.addEventListener('click', removeActive);

        function removeActive () {
            userDropdownList.classList.remove('user-dropdown__list_active');
            document.removeEventListener('click', removeActive);
        }
    });

    containersForGreeting.forEach( container => {
        container.innerHTML = getGreeting(new Date()) + ', ';
    });

    /**
     *
     * @param date
     * @returns {string}
     */
    function getGreeting(date) {
        const hours = date.getHours();

        if (hours >= 5 && hours < 10) return m.trans.get('Good Morning');
        else if (hours >= 10 && hours < 13) return m.trans.get('Good Day');
        else if (hours >= 13 && hours < 18) return m.trans.get('Good Afternoon');
        else if (hours >= 18 && hours < 23) return m.trans.get('Good Evening');

        return m.trans.get('Good Night');
    }

    const links = document.querySelectorAll('.js-desktop-menu .menu-item-has-children:not(.menu-item-service) a[href*="#"]');

    for (let link of links) {
        link.addEventListener('click', function (e) {
            e.preventDefault();
        });
    }
});